import language from "#scripts/translation";

export const campaigns = (obj) => {
    return `
        <section id="module__campaigns_${obj.moduleID}" class="module__campaigns ${obj.campaignDesign || "medium"} ${obj.campaignImagePos} p-md-0 justify-content-md-center">
            <div class="container p-0">
                <div class="campaign ${obj.maxItems === 1 ? "single" : ""}" id="campaigns_${obj.moduleID}"></div>
            </div>
        </section>`;
};

export const campaignItem = (obj) => {
    const bgStyle = obj.bgcolor ? `--current_campaign_bgcolor: ${obj.bgcolor};--current_campaign_textcolor: ${obj.color}; background-color:${obj.bgcolor};` : "";
    const colorStyle = obj.color ? `color:${obj.color};` : "";

    // if (obj.campaignDesign === "large") {
    //     return `
    //         <div class="campaign__item" ${bgStyle ? `style="${bgStyle}"` : ""}>
    //             <div class="campaign__content">
    //                 <p class="campaign__title">
    //                     ${obj.forsidetittel}${obj.link.substring(0, 4) === "http" ? ` <span class="material-icons-outlined notranslate campaign__title__icon-external_link">&#xE89E;</span>` : ""}</p>
    //                 <p class="campaign__text"${colorStyle ? `style="${colorStyle}"` : ""}>${obj.forsidetekst}</p>
    //                 <a class="campaign__item" 
    //                 ${obj.link.substring(0, 4) === "http" ? `href="${obj.link}" aria-label="${obj.forsidetittel} (${language("NAV_OPEN_I_NEW")})" target="_blank"` : `href="${obj.link}"`}
    //                 ${bgStyle ? `style="${bgStyle}"` : ""}>${obj.moduleCardButtontext}</a>
    //             </div>
    //             ${obj.image}
    //         </div>
    //     `;
    // }
    return `
        <a class="campaign__item" ${obj.link.substring(0, 4) === "http" ? `href="${obj.link}" aria-label="${obj.forsidetittel} (${language("NAV_OPEN_I_NEW")})" target="_blank"` : `href="${obj.link}"`
        } ${bgStyle ? `style="${bgStyle}"` : ""}>
            ${obj.image}
            <div class="campaign__content">
                <span class="campaign__title">${obj.forsidetittel}
                    ${obj.link.substring(0, 4) === "http" ? ` <span class="material-icons-outlined notranslate campaign__title__icon-external_link">&#xE89E;</span>` : ""}
                </span>
                <p class="campaign__text"${colorStyle ? `style="${colorStyle}"` : ""}>${obj.forsidetekst}</p>
            </div>
        </a>
    `;
};


export const campaignItem2 = (obj) => {
    let html = "";
    const bgStyle = obj.bgcolor ? `--current_campaign_bgcolor: ${obj.bgcolor};--current_campaign_textcolor: ${obj.color}; background-color:${obj.bgcolor};` : "";
    const colorStyle = obj.color ? `color:${obj.color};` : "";

    const isExternalLink = obj.link.startsWith('http');
    const href = obj.link;
    const ariaLabel = isExternalLink ? `aria-label="${obj.forsidetittel} (${language('NAV_OPEN_I_NEW')})"` : '';
    const target = isExternalLink ? 'target="_blank"' : '';
    const backgroundStyle = bgStyle ? `style="${bgStyle}"` : '';
    const textStyle = colorStyle ? `style="${colorStyle}"` : '';
    const externalIcon = isExternalLink ? `<span class="material-icons-outlined notranslate campaign__title__icon-external_link d-none">&#xE89E;</span>`  : '';
    const button = obj.moduleCardButtontext ? `<a class="campaign__button" href="${href}" ${ariaLabel} ${target}>${obj.moduleCardButtontext} ${externalIcon}</a>` : '';
    if (obj.campaignDesign === "large") {
        html = `
        <div class="campaign__item" ${backgroundStyle}>
            ${obj.image}
            <div class="campaign__content">
                <span class="campaign__title">
                    ${obj.forsidetittel}
                </span>
                <p class="campaign__text" ${textStyle}>${obj.forsidetekst || "&nbsp;"}</p>
                ${button}
            </div>
        </div>
    `;
    } 
    else {
    html = `
        <a class="campaign__item" href="${href}" ${ariaLabel} ${target} ${backgroundStyle}>
            ${obj.image}
            <div class="campaign__content">
                <span class="campaign__title">
                    ${obj.forsidetittel} 
                    ${externalIcon}
                </span>
                <p class="campaign__text" ${textStyle}>${obj.forsidetekst}</p>
            </div>
        </a>
    `;
}

    return html;
};
export default campaigns;
